import React, { createContext, useContext, useEffect, useState } from 'react';
import { api } from './api';

const AuthContext = createContext({ user: null, loading: true, login: async () => {}, signup: async () => {}, logout: () => {} });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('wyse_token');
    if (!token) { setLoading(false); return; }
    api.me().then((u) => setUser(u)).catch(() => {
      localStorage.removeItem('wyse_token');
      localStorage.removeItem('wyse_user');
    }).finally(() => setLoading(false));
  }, []);

  const login = async (email, password, turnstileToken = '') => {
    const data = await api.login(email, password, turnstileToken);
    localStorage.setItem('wyse_token', data.access_token);
    localStorage.setItem('wyse_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const signup = async (payload, turnstileToken = '') => {
    const data = await api.signup(payload, turnstileToken);
    localStorage.setItem('wyse_token', data.access_token);
    localStorage.setItem('wyse_user', JSON.stringify(data.user));
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem('wyse_token');
    localStorage.removeItem('wyse_user');
    setUser(null);
  };

  const refresh = () => {
    try {
      const cached = localStorage.getItem('wyse_user');
      if (cached) setUser(JSON.parse(cached));
    } catch { /* ignore */ }
  };

  return <AuthContext.Provider value={{ user, setUser, loading, login, signup, logout, refresh }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);

export function dashboardFor(role) {
  if (role === 'admin' || role === 'advisor' || role === 'tax_specialist') return '/admin';
  return '/account';
}
